var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.shouldDisplayAddedDays())?_c('div',{staticClass:"added-date__wrapper"},[_c('div',{staticClass:"added-date__value"},[_c('span',[_vm._v(_vm._s(_vm.getAddedInDaysText()))])])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }